<template>
  <div class="allbox">
    <!--    <div class="top_inrwe">-->
    <div style="margin-bottom:20px;">
      <div class="container">
        <div class="row">
          <div class="column">
            <el-input
              v-model="query.keywords"
              class="inptw"
              placeholder="请输入公众号appId/gh_id"
            />
          </div>
          <div class="column">
            <el-input
              v-model="query.account_name"
              class="inptw"
              placeholder="请输入公众号名称"
            />
          </div>
          <div class="column">
            <el-select
              v-model="query.platform_id"
              filterable
              placeholder="请选择平台"
            >
              <el-option
                v-for="item in accoutarr"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </div>
          <div class="column">
            <el-select
              v-model="query.status"
              placeholder="请选择授权状态"
            >
              <el-option
                v-for="item in options"
                :key="item.id"
                :label="item.text"
                :value="item.id"
              />
            </el-select>
          </div>
          <div class="column">
            <el-select
              v-model="query.operation_status"
              placeholder="请选择运营状态"
            >
              <el-option
                v-for="item in yunoptions"
                :key="item.id"
                :label="item.text"
                :value="item.id"
              />
            </el-select>
          </div>
          <div class="column">
            <el-select
              v-model="query.basic_account"
              placeholder="请选择是否为基础号"
            >
              <el-option
                v-for="item in basenoarr"
                :key="item.id"
                :label="item.text"
                :value="item.id"
              />
            </el-select>
          </div>
          <div class="column">
            <el-select
              v-model="query.onlyMe"
              placeholder="请选择"
            >
              <el-option
                v-for="item in accountarr"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </div>
        </div>
        <div class="row">
          <div class="column">
            <el-select
              v-model="query.qualification_verify"
              placeholder="是否资质认证"
            >
              <el-option
                v-for="item in qualificationReviewarr"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </div>
          <div class="column">
            <el-select
              v-model="query.annual_review"
              placeholder="是否需要年审"
            >
              <el-option
                v-for="item in annualReviewarr"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </div>
          <div class="column">
            <el-date-picker
              v-model="date"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetimerange"
              range-separator="至"
              start-placeholder="年审开始时间"
              end-placeholder="年审截止时间"
              @change="tinwewboce"
            />
          </div>
          <div class="column">
            <el-input
              v-model="query.remark"
              class="inptw"
              placeholder="请输入备注"
            />
          </div>
          <div class="column">
            <div style="display: flex;">
              <el-button
                type="primary"
                class="searchurl"
                style="background-color: #165DFF"
                icon="el-icon-search"
                @click="searchclick"
              >搜索</el-button>
              <el-button
                type="info"
                icon="el-icon-refresh"
                @click="reset"
              >重置</el-button>
            </div>
          </div>
          <div class="column">
            <div />
          </div>
          <div class="column button-group">
            <div>
              <el-button
                style="background-color: #FF7D00;color: #f0f0f0"
                icon="el-icon-check"
                @click="authorizationclick"
              >授权</el-button>
              <el-button
                style="background-color: #00B42A;color: #f0f0f0"
                icon="el-icon-refresh"
                @click="refreshfansw"
              >一键刷新组内粉丝数</el-button>
              <el-button
                type="primary"
                icon="el-icon-download"
                @click="exportlisrwdaw"
              >导出</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-table
      ref="multipleTable"
      v-loading="loadingtable"
      :data="tableData"
      border
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <!-- <el-table-column
        type="selection"
        width="55"
      /> -->
      <el-table-column
        prop="accountName"
        label="公众号名称"
        width="100"
        align="center"
      />
      <el-table-column
        prop="ghId"
        label="原始ID"
        width="150"
        align="center"
      />
      <el-table-column
        label="公众号appid"
        width="170"
        align="center"
      >
        <template slot-scope="scope">{{ scope.row.appId }}</template>
      </el-table-column>
      <el-table-column
        prop="platformIdText"
        label="所属平台"
        width="80"
        align="center"
      />
      <el-table-column
        label="运营状态"
        width="80"
        align="center"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.operationStatus == 1">
            <i
              v-if="scope.row.operationStatus == 1"
              class="el-icon-success defaultr"
            />
            在跑
          </div>
          <div v-if="scope.row.operationStatus == 2">
            <i
              v-if="scope.row.operationStatus == 2"
              class="el-icon-warning"
            />
            停跑
          </div>
          <div v-if="scope.row.operationStatus == 3">
            <i
              v-if="scope.row.operationStatus == 3"
              class="el-icon-error stopew"
            />
            永封
          </div>
        </template>
      </el-table-column>

      <el-table-column
        label="状态"
        width="100"
        align="center"
      >
        <template slot-scope="scope">
          <el-tag
            v-if="scope.row.status === 1"
            type="warning"
          >{{ scope.row.statusStr }}</el-tag>
          <el-tag
            v-else-if="scope.row.status === 2"
            type="success"
          >{{ scope.row.statusStr }}</el-tag>
          <el-tag
            v-else-if="scope.row.status === 9"
            type="danger"
          >{{ scope.row.statusStr }}</el-tag>
          <el-tag
            v-else
            type="info"
          >{{ scope.row.statusStr }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        label="头像"
        width="100"
        align="center"
      >
        <template slot-scope="scope">
          <img
            v-if="scope.row.headImg"
            :src="scope.row.headImg"
            class="head_column"
          >
          <span v-else>暂无</span>
        </template>
      </el-table-column>
      <el-table-column
        label="二维码"
        width="130"
        align="center"
      >
        <template slot-scope="scope">
          <!-- <iframe :src="scope.row.qrcodeUrl" /> -->
          <img
            v-if="scope.row.qrcodeUrl"
            :src="scope.row.qrcodeUrl"
            class="QRcode"
            @click="lookqrcode(scope.row.qrcodeUrl)"
          >
          <span v-else>暂无</span>
        </template>
      </el-table-column>
      <el-table-column
        label="归属人(ID)"
        width="130"
        align="center"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.adminName }}({{ scope.row.adminId }})</span>
        </template>
      </el-table-column>
      <el-table-column
        label="错误信息/备注"
        width="160"
        align="center"
      >
        <template slot-scope="scope">
          <span
            v-for="item,index in scope.row.exceptionInfo"
            :key="index"
          >{{ item }}</span><span v-if="scope.row.remark">/{{ scope.row.remark }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="principalName"
        label="主体名称"
        width="150"
        align="center"
      />
      <el-table-column
        prop="qualificationVerifyStr"
        label="是否资质认证"
        width="100"
        align="center"
      >
        <template slot-scope="scope">
          {{ scope.row.qualificationVerifyStr }}
        </template>
      </el-table-column>
      <el-table-column
        prop="annualReviewStr"
        label="是否需要年审"
        width="100"
        align="center"
      >
        <template slot-scope="scope">
          {{ scope.row.annualReviewStr }}
        </template>
      </el-table-column>
      <el-table-column
        prop="annualReviewBeginTime"
        label="年审开始"
        width="180"
        align="center"
      >
        <template slot-scope="scope">
          {{ scope.row.annualReviewBeginTime }}
        </template>
      </el-table-column>
      <el-table-column
        prop="annualReviewEndTime"
        label="年审截止"
        width="180"
        align="center"
      >
        <template slot-scope="scope">
          {{ scope.row.annualReviewEndTime }}
        </template>
      </el-table-column>
      <el-table-column
        prop="alias"
        label="公众号设置的微信号"
        width="130"
        align="center"
      />
      <el-table-column
        prop="fansNumber"
        label="粉丝数"
        width="80"
        align="center"
      />

      <el-table-column
        prop="verifyTypeStr"
        label="公众号认证类型"
        width="120"
        align="center"
      />
      <el-table-column
        prop="serviceTypeStr"
        label="公众号类型"
        width="220"
        align="center"
      />
      <el-table-column
        label="操作"
        align="center"
        width="330"
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            style="color: #13CE66"
            @click.stop="look(scope.row)"
          >查看数据</el-button>
          <el-button
            type="text"
            style="color: #909399"
            @click="bindingclick(scope.row)"
          >绑定策略</el-button>
          <el-button
            type="text"
            style="color: #FFBA00"
            @click="edit(scope.row)"
          >编辑</el-button>
          <!-- <el-button size="mini" type="primary" @click="refreshuser(scope.row.appId)">{{ '刷新用户' }}</el-button> -->
          <el-dropdown
            trigger="click"
            style="margin-left: 9px"
            placement="bottom"
          >
            <span
              class="el-dropdown-link"
              style="cursor: pointer;"
            >
              更多
              <i class="el-icon-arrow-down el-icon--right" />
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <el-button
                  type="text"
                  class="el-button-new"
                  icon="el-icon-tickets"
                  @click.stop="bangd(scope.row.funcscopeCategory,0)"
                >查看授权信息</el-button>
              </el-dropdown-item>
              <el-dropdown-item>
                <el-button
                  type="text"
                  class="el-button-new"
                  icon="el-icon-connection"
                  @click.stop="bangd(scope.row,1)"
                >查看绑定策略</el-button>
              </el-dropdown-item>
              <el-dropdown-item>
                <el-button
                  :loading="updatafansbool"
                  type="text"
                  class="el-button-new"
                  icon="el-icon-refresh"
                  @click="refreshfans(scope.row.appId)"
                >{{ updatafansbool === true ? '刷新中' :'刷新粉丝数' }}</el-button>
              </el-dropdown-item>
              <el-dropdown-item>
                <el-button
                  type="text"
                  class="el-button-new"
                  icon="el-icon-unlock"
                  @click.stop="bandmenuall(scope.row)"
                >解绑菜单</el-button>
              </el-dropdown-item>
              <el-dropdown-item>
                <el-button
                  type="text"
                  class="el-button-new"
                  icon="el-icon-refresh-right"
                  @click.stop="updataemnu(scope.row.appId)"
                >刷新菜单</el-button>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <!-- {{ scope.row }} -->
          <!-- <img :src="scope.row. qrcodeUrl" class="QRcode"> -->
        </template>
      </el-table-column>

    </el-table>
    <!-- 绑定策略 授权信息 弹窗 -->
    <el-dialog
      title="查看"
      :visible.sync="bandVisible"
      :modal-append-to-body="false"
      :append-to-body="true"
      @close="getofflist"
    >
      <Banddialog
        ref="Banddialogview"
        @goruter="goruter"
      />
    </el-dialog>
    <pagination-right
      :current-page="query.page"
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />

    <el-dialog
      v-if="dialogVisible1"
      title="授权"
      :visible.sync="dialogVisible1"
      @close="dialogVisible1 = false"
    >
      <iframe
        width="100%"
        height="600"
        marginwidth="0"
        marginheight="0"
        frameborder="0"
        scrolling="no"
        :src="iframeURL"
      />
    </el-dialog>
    <el-dialog
      title="绑定策略"
      :visible.sync="banddialog"
      :destroy-on-close="true"
    >
      <bindingpolicy
        ref="bandcelue"
        @onbangaccout="onbangaccout"
      />
    </el-dialog>
    <el-dialog
      title="查看二维码"
      :visible.sync="erweimadialog"
      :destroy-on-close="true"
    >
      <div style="text-align: center;">
        <img
          :src="erweimaimg"
          class="ercaoder"
        >
      </div>
    </el-dialog>
    <el-dialog
      title="绑定记录"
      :visible.sync="dialogVisiblenotes"
      :close-on-click-modal="false"
      :destroy-on-close="true"
    >
      <bandmenu
        ref="bandstaffnotesview"
        @updata="updata"
      />
    </el-dialog>
  </div>
</template>

<script>
import { officialAccountlist, wechatauth, strategyPlatform, officialAccountexport, updatafans, updatausers, officialAccountMenurefreshMenus } from '@/api/sourceMaterial.js'
import bandmenu from './components/bandmenu.vue'
import PaginationRight from '@/components/PaginationRight/index.vue'
import Banddialog from './components/banddialog.vue'
import bindingpolicy from './components/bindingpolicy.vue'
import { mapGetters } from 'vuex'
import convertToHump from '@/utils/mixins/convertToHump.js'
export default {
  components: {
    PaginationRight,
    Banddialog,
    bindingpolicy,
    bandmenu
  },
  mixins: [convertToHump],
  data() {
    return {
      bandVisible: false,
      loadingtable: false,
      input: '',
      input1: '',
      options: [
        {
          text: '待绑定',
          id: 1
        },
        {
          text: '绑定成功',
          id: 2
        },
        {
          text: '绑定失败',
          id: 3
        },
        {
          text: '取消授权',
          id: 4
        }
      ],
      yunoptions: [
        {
          text: '在跑',
          id: 1
        },
        {
          text: '停跑',
          id: 2
        },
        {
          text: '永封',
          id: 3
        }
      ],
      basenoarr: [
        {
          text: '是',
          id: 2
        },
        {
          text: '否',
          id: 1
        }
      ],
      qualificationReviewarr: [
        {
          value: 1,
          label: '是'
        },
        {
          value: 2,
          label: '否'
        }
      ],
      value: '',
      tableData: [],
      multipleSelection: [],
      // 列表参数
      query: {
        keywords: null,
        account_name: null,
        status: null,
        page: 1,
        pageSize: 10,
        platform_id: null,
        operation_status: null,
        basic_account: null,
        onlyMe: 2,
        annual_review: null,
        annual_review_begin_time: null,
        annual_review_end_time: null,
        remark: null,
        qualification_verify: null
      },
      accountarr: [
        {
          value: 1,
          label: '查看组内公众号'
        },
        {
          value: 2,
          label: '我关联的公众号'
        }
      ],
      annualReviewarr: [
        {
          value: 1,
          label: '是'
        },
        {
          value: 2,
          label: '否'
        }
      ],
      dialogVisible1: false,
      ids: 1,
      iframeURL: '',
      banddialog: false,
      total: null,
      erweimadialog: false,
      erweimaimg: null,
      accoutarr: [],
      updatafansbool: false,
      updatauserbool: false,
      dialogVisiblenotes: false,
      date: []
    }
  },
  computed: {
    ...mapGetters(['id']),
    msgNum: {
      get() {
        return this.id
      },
      set(val) {
        this.setNoticeNum(val)
      }
    }
  },
  watch: {
    msgNum(newVal, oldVal) {
      console.log('newVal', newVal)
      // this.iframeURL = `http://operation.jingxuansz.com/authorize/page?adminId=${newVal}`
    }
  },
  created() {
    this.getofflist()
    this.getstrategyplatform()
  },
  mounted() {
    const ajaxPath = this.id
    console.log('ajaxPath', ajaxPath)
  },
  methods: {
    goruter() {
      this.bandVisible = false
    },
    async exportlisrwdaw() {
      this.$confirm('确定要导出吗？ 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      })
        .then(() => {
          officialAccountexport({
            keywords: this.query.keywords === null ? '' : this.query.keywords,
            account_name: this.query.account_name === null ? '' : this.query.account_name,
            platform_id: this.query.platform_id === null ? '' : this.query.platform_id,
            operation_status: this.query.operation_status === null ? '' : this.query.operation_status,
            status: this.query.status === null ? '' : this.query.status,
            basic_account: this.query.basic_account === null ? '' : this.query.basic_account,
            onlyMe: this.query.onlyMe
          }).then(res => {
            console.log('res', res)
            this.$message({
              type: 'success',
              message: '导出成功!'
            })
            window.open(res.data.url, '_blank')
          })
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // })
        })
    },
    // 获取平台
    async getstrategyplatform() {
      const data = await strategyPlatform()
      this.accoutarr = data.data.list
    },
    setNoticeNum(id) {
      console.log(id)
    },
    async getofflist() {
      this.loadingtable = true
      const data = await officialAccountlist(this.query)
      this.tableData = this.convertToHump(data.data.list)
      this.total = data.data.total
      this.loadingtable = false
    },
    // 分页
    fetchPageSize(e) {
      this.query.pageSize = e
      this.getofflist()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.getofflist()
    },
    handleSelectionChange(val) {
      this.multipleSelection = []
      // this.multipleSelection = val
      val.map((item, index) => {
        this.multipleSelection.push(item.date)
      })
      console.log('this.multipleSelection', this.multipleSelection)
    },
    searchclick() {
      this.query.page = 1
      this.getofflist()
    },
    reset() {
      this.query = {
        keywords: null,
        account_name: null,
        status: null,
        page: 1,
        pageSize: 10,
        platform_id: null,
        operation_status: null,
        onlyMe: 2,
        basic_account: null,
        annual_review: null,
        annual_review_begin_time: null,
        annual_review_end_time: null,
        remark: null,
        qualification_verify: null
      }
      this.date = []
      this.getofflist()
    },
    bangd(arr, id) {
      this.bandVisible = true
      if (id === 0) {
        console.log('arr', arr)
        setTimeout(() => {
          // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
          this.$refs.Banddialogview.sendr(arr, 0)
        }, 100)
      } else {
        setTimeout(() => {
          // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
          this.$refs.Banddialogview.sendr(arr, 1)
        }, 100)
      }
    },
    look(item) {
      this.$router.push({ path: '/userAnalysis/index', query: { appId: item.appId }})
    },
    authorizationclick() {
      this.dialogVisible1 = true
      wechatauth().then(res => {
        console.log('res.data.url', res.data.url)
        this.iframeURL = res.data.url
      })
      // const data = await wechatauth()
      // this.iframeURL = data.data.url
    },
    bindingclick(item) {
      this.banddialog = true
      setTimeout(() => {
        // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.bandcelue.sendbind(item)
      }, 100)
    },
    onbangaccout() {
      this.banddialog = false
      this.getofflist()
    },
    edit(item) {
      console.log('1111', item)
      this.$router.push({ path: '/officialaccountlook/index', query: { appId: item.appId }})
    },
    lookqrcode(url) {
      this.erweimadialog = true
      this.erweimaimg = url
    },
    // 刷新粉丝数
    async refreshfans(appid) {
      try {
        this.updatafansbool = true
        const data = await updatafans({
          app_id: appid
        })
        this.$message({
          message: '刷新成功',
          type: 'success'
        })
        this.updatafansbool = false
        this.getofflist()
        console.log('data', data)
      } catch (err) {
        this.updatafansbool = false
      }
    },
    // 刷新用户
    async refreshuser(appid) {
      try {
        // this.updatauserbool = true
        const data = await updatausers({
          app_ids: [appid]
        })
        this.$message({
          message: '刷新用户成功',
          type: 'success'
        })
        // this.updatauserbool = false
        this.getofflist()
        console.log('data', data)
      } catch (err) {
        // this.updatauserbool = false
      }
    },
    bandmenuall(item) {
      console.log('item', item.appId)
      this.dialogVisiblenotes = true
      this.$nextTick(() => {
        this.$refs.bandstaffnotesview.send(item.appId)
      })
    },
    updata() {
      this.dialogVisiblenotes = false
      this.getofflist()
    },
    async updataemnu(app_id) {
      const data = await officialAccountMenurefreshMenus({
        app_id: app_id
      })
      this.$message({
        message: `${data.message}`,
        type: 'success'
      })
      this.getofflist()
      console.log(data)
    },
    async refreshfansw() {
      try {
        const data = await updatafans({
          type: 2,
          app_id: ''
        })
        this.$message({
          message: `${data.message}`,
          type: 'success'
        })
        this.getofflist()
        console.log('data', data)
      } catch (err) {
        console.log(err)
      }
    },
    tinwewboce(val) {
      console.log('val', val)
      if (val === null) {
        this.query.annual_review_begin_time = ''
        this.query.annual_review_end_time = ''
      } else {
        this.query.annual_review_begin_time = val[0]
        this.query.annual_review_end_time = val[1]
      }
    }
  }
}
</script>

<style scoped>
.allbox {
  padding: 30px;
}
.searchtext {
  margin-right: 10px;
}
.search-btn {
  margin-left: 10px;
}
.middlebox {
  margin: 20px 0px 20px 0px;
}
.prbtn {
  margin-right: 10px;
}
.head_column {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
.QRcode {
  width: 80px;
  height: 80px;
}
.inptw {
  width: 250px;
}
.searchurl {
  margin-left: 10px;
}
.defaultr {
  color: #67c23a;
}
.stopew {
  color: red;
}
.ercaoder {
  width: 200px;
  height: 200px;
}
.container {
  display: flex;
  flex-direction: column;
  gap: 20px; /* 每一行之间的间距 */
}

.row {
  display: flex;
  gap: 20px; /* 列与列之间的间距 */
}

.column {
  flex-basis: 12.5%;
  flex-grow: 2;
  display: flex;
  flex-direction: column;
}
.column input {
  padding: 5px 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  width: 200px; /* 控制输入框宽度 */
}

.button-group {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  flex-wrap: nowrap;
  white-space: nowrap;
}
@media (max-width: 768px){
  .containe,.row{
    flex-wrap:wrap;
  }
  .column{
    width:100%;
    flex-basis: 30.5%;
  }
  .el-date-editor--datetimerange.el-input__inner {
    width:300px;
  }
}
</style>

